import OrganizationListReducer from './OrganizationListReducer';

export default from './OrganizationListContainer';
export const OrganizationListReducers = {
  OrganizationListReducer,
};
